import { useSyncExternalStore } from "react";
import { getWorkspaceSession } from "../workspace/use-workspace";
import { RunSession } from "./run-session";
import { TerminalSharing } from "./run-sharing";

let session: RunSession | undefined;
export function getRunSession(): RunSession {
  session ??= new RunSession();
  return session;
}

let sharing: TerminalSharing | undefined;
export function getTerminalSharing(): TerminalSharing {
  sharing ??= new TerminalSharing(getRunSession());
  return sharing;
}

export function useRun() {
  const run = getRunSession();
  const status = useSyncExternalStore(
    (listener) => run.subscribe(listener),
    () => run.status,
  );
  return { run, status };
}

/** The latest test results on this device. */
export function useTestResults() {
  const run = getRunSession();
  return useSyncExternalStore(
    (listener) => run.subscribeTests(listener),
    () => run.tests,
  );
}

/** The room's live run sessions (everyone's, including ours). */
export function useRunSessions() {
  const workspace = getWorkspaceSession();
  return useSyncExternalStore(
    (listener) => workspace.subscribeSessions(listener),
    () => workspace.sessionList,
  );
}

export function useTerminalSharing() {
  const sharing = getTerminalSharing();
  const state = useSyncExternalStore(
    (listener) => sharing.subscribe(listener),
    () => sharing.state,
  );
  return { sharing, state };
}
